var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvoidanceLeftIcon = function SvgAvoidanceLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 134,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3FFE6",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M75.495 24.5c.032 7.396.627 16.122 7.505 23l30 30c11.5 11.5 12 26 12 32V129H95v-15.5c0-8.5-3.5-16-12-24.5L60 66C48 54 45 46 45 32.5v-8h-5L60.5 4 81 24.5h-5.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 4,
    transform: "matrix(-1 0 0 1 137 10)"
  })));
};
export default SvgAvoidanceLeftIcon;